import React from "react";
import { Container, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTriangleExclamation } from "@fortawesome/free-solid-svg-icons";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <Container
      fluid
      className="d-flex flex-column align-items-center justify-content-center text-center"
      style={{
        height: "100vh",
        background:
          "radial-gradient(circle at center, #2a6f9e 0%, #004172 65%)",
        color: "white",
      }}
    >
      <h1
        style={{
          fontSize: "110px",
          fontWeight: "700",
          letterSpacing: "4px",
          marginBottom: "10px",
        }}
      >
        404
      </h1>

      <h4 style={{ marginBottom: "10px", fontWeight: 600 }}>
        {" "}
        <FontAwesomeIcon icon={faTriangleExclamation} className="me-2" /> Page
        Not Found
      </h4>

      <p
        style={{
          maxWidth: "420px",
          opacity: 0.85,
          marginBottom: "30px",
        }}
      >
        The page you are looking for doesn’t exist or may have been moved.
        Please check the URL or return to the home page.
      </p>

      <div className="d-flex gap-3">
        <Button
          variant="outline-light"
          className="rounded-3"
          onClick={() => navigate("/")}
          style={{
            padding: "10px 20px",
            fontWeight: 500,
          }}
        >
          Back to Login
        </Button>
      </div>
    </Container>
  );
};

export default NotFound;
